module.exports = __webpack_public_path__ + "media/images/flags/4x3/hkg-5043f05f6522038d4ede47b979cb79aa.svg";